/* Plugin for window.TinyMCE 5 to insert an expandable list. Copyright © 2021 Kontextlab GmbH. All rights reserved. */
import useI18nGlobal from '@/utils/i18n';

const {i18n} = useI18nGlobal();
const {t} = i18n.global;

export default function (editor) {
  const listName = 'UL';
  const listItemName = 'LI';
  const listClasses = 'accordion';

  editor.ui.registry.addIcon('accordionk',
    '<svg width="24" height="24">' +
    '<path d="m11.5 4.5547c-1.9995-5.163e-4 -1.9995 2.9995 0 3h7c0.9 0 1.5-0.6 1.5-1.5s-0.6-1.5-1.5-1.5h-7zm-6.9141 0.11719-0.70703 0.70703 2.1211 2.1211 2.1211-2.1211-0.70703-0.70703-1.4141 1.4141-1.4141-1.4141zm6.3848 6.3281a1 1 0 0 0 0.029297 2h8c0.6 0 1-0.4 1-1s-0.4-1-1-1h-8a1 1 0 0 0-0.029297 0zm0 6a1 1 0 0 0 0.029297 2h8c0.6 0 1-0.4 1-1s-0.4-1-1-1h-8a1 1 0 0 0-0.029297 0z"/>' +
    '</svg>'
  );

  function _onAction() {
    const selection = editor.selection;
    if (selection.isCollapsed()) {
      editor.insertContent(
        `<${listName} class="${listClasses}">` +
        `  <${listItemName}>${t('tinymce.expandableTitle')}</${listItemName}>` +
        `  <${listItemName}>${t('tinymce.expandableContent')}</${listItemName}>` +
        `</${listName}>`
      );
    } else {
      const dom = editor.dom;
      const nodes = selection.getSelectedBlocks();
      const listBlock = dom.create(listName, {'class': listClasses});
      nodes[0].parentNode.insertBefore(listBlock, nodes[0]);
      nodes.forEach(block => {
        dom.remove(block);
        listBlock.appendChild(block);
        dom.rename(block, listItemName);
      });
    }
  }

  editor.ui.registry.addButton('accordionk', {
    get tooltip() {
      return t('tinymce.expandableList')
    },
    icon: 'accordionk',
    onAction: _onAction
  });

  editor.ui.registry.addMenuItem('accordionk', {
    context: 'insert',
    get text() {
      return t('tinymce.expandableList')
    },
    icon: 'accordionk',
    onAction: _onAction
  });
}
